import * as THREE from 'three';

export const TRAP_VARIANTS = ['freeze', 'stun', 'immobility'];
export const getTrapVariant = (effect) =>
  TRAP_VARIANTS.includes(effect?.variant) ? effect.variant : 'freeze';

// Cosmetic restraint only. Combat owns the skipped turn and retaliation.
export const createTrapScene = (scene) => {
  const group = new THREE.Group();
  group.name = 'die-trap-restraint';
  group.visible = false;
  scene.add(group);
  const material = new THREE.MeshBasicMaterial({
    color: '#9bcaff',
    transparent: true,
    opacity: 0.65,
    wireframe: true,
    depthWrite: false,
  });
  const ice = new THREE.Mesh(new THREE.IcosahedronGeometry(0.9, 0), material);
  const stars = new THREE.Group();
  for (let index = 0; index < 5; index++) {
    const star = new THREE.Mesh(new THREE.OctahedronGeometry(0.13), material);
    const angle = (index * Math.PI * 2) / 5;
    star.position.set(Math.cos(angle) * 0.8, 0.8, Math.sin(angle) * 0.8);
    stars.add(star);
  }
  const bands = new THREE.Group();
  for (let index = 0; index < 3; index++) {
    const band = new THREE.Mesh(
      new THREE.TorusGeometry(0.78, 0.035, 5, 32),
      material
    );
    band.rotation.set(Math.PI / 2, (index * Math.PI) / 3, 0);
    bands.add(band);
  }
  group.add(ice, stars, bands);
  return {
    group,
    update({ effect, position, elapsed, visible, reduceMotion }) {
      group.visible = !!effect && visible;
      if (!group.visible) return;
      const variant = getTrapVariant(effect);
      group.userData.variant = variant;
      group.position.copy(position);
      ice.visible = variant === 'freeze';
      stars.visible = variant === 'stun';
      bands.visible = variant === 'immobility';
      material.color.set(
        variant === 'stun'
          ? '#ffe079'
          : variant === 'immobility'
          ? '#b69aff'
          : '#9bcaff'
      );
      material.opacity = reduceMotion
        ? 0.55
        : 0.55 + Math.sin(elapsed * 3) * 0.1;
      ice.scale.setScalar(reduceMotion ? 1 : 1 + Math.sin(elapsed * 2) * 0.025);
      stars.rotation.y = reduceMotion ? 0 : elapsed * 1.4;
      bands.rotation.y = reduceMotion ? 0 : Math.sin(elapsed) * 0.08;
    },
    dispose() {
      group.traverse((object) => object.geometry?.dispose());
      material.dispose();
      group.removeFromParent();
    },
  };
};
